import { Directionality } from '@angular/cdk/bidi';
import { CdkStepper } from '@angular/cdk/stepper';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    providers: [{ provide: CdkStepper, useExisting: BreadcrumbComponent }],
    standalone: false
})
export class BreadcrumbComponent  extends CdkStepper {
  
  @Input() header:string[] = [];
  @Output() headerClicked:EventEmitter<number> = new EventEmitter();

  onClick(index: number): void {
    this.selectedIndex = index;
    
  }


  removeFront(index:number):void{
    this.headerClicked.emit(index);
  }
  
}
